import {isIde} from "../../misc/envNameUtils.ts";

const getDefaultPremiumModel = () => {
    return "Claude-Sonnet";
}

const getBestAvailableApiKeyModel = (anthropicApiKey: boolean, openAiApiKey: boolean, xAiApiKey: boolean, geminiApiKey: boolean) => {
    if (anthropicApiKey) return "Claude-Sonnet";
    else if (openAiApiKey) return "GPT";

    if (geminiApiKey) return "Gemini-Pro";
    else if (xAiApiKey) return "Grok";
}

const getAutomaticGeminiModel = (canUsePremium: boolean, apiKeyOnly: boolean, geminiApiKey: boolean) => {
    if (apiKeyOnly) {
        return geminiApiKey ? "Gemini-Pro" : undefined;
    }

    return canUsePremium ? "Gemini-Pro" : "Gemini-Flash";
}

export const getAutomaticModel = (subscriptionPlan: string | null, canUsePremium: boolean, mode: string, environment: string, numOfImages: number, convoHasAudio: boolean, convoHasVideo: boolean, approxTokens: number, apiKeyOnly: boolean, anthropicApiKey: boolean, openAiApiKey: boolean, xAiApiKey: boolean, geminiApiKey: boolean) => {
    const automaticGeminiModel = getAutomaticGeminiModel(canUsePremium, apiKeyOnly, geminiApiKey);
    const defaultPremiumModel = getDefaultPremiumModel();

    // Audio/video MUST use Gemini - no other model supports these
    if ((convoHasAudio || convoHasVideo) && automaticGeminiModel) {
        return automaticGeminiModel;
    }

    if (approxTokens >= 120000 && automaticGeminiModel) {
        return automaticGeminiModel;
    }

    if (apiKeyOnly) return getBestAvailableApiKeyModel(anthropicApiKey, openAiApiKey, xAiApiKey, geminiApiKey);

    // Mini model selection defaults to Gemini-Flash across environments.
    let defaultMiniModel;

    if (numOfImages > 0) {
        defaultMiniModel = "Gemini-Flash";
    }
    else if (numOfImages > 10) {
        defaultMiniModel = "Gemini-Flash";
    }
    else {
        defaultMiniModel = "Gemini-Flash";
    }

    if (!canUsePremium || subscriptionPlan === null) return defaultMiniModel;

    // Premium model selection defaults to Claude-Sonnet when Gemini is not required.
    if (numOfImages > 0) {
        if (numOfImages >= 10) return defaultPremiumModel;
        else if (approxTokens >= 190000) return defaultPremiumModel;

        else if (isIde(environment)) return defaultPremiumModel;
        else if (environment === "chrome") return defaultPremiumModel;
        else if (environment.includes("mobile")) return defaultPremiumModel;
        else if (environment.includes("web")) return defaultPremiumModel;

        else return defaultPremiumModel;
    }
    else {
        if (approxTokens >= 190000) return defaultPremiumModel;
        else if (approxTokens <= 45000 && mode === "chat") return defaultPremiumModel;

        else if (isIde(environment)) return defaultPremiumModel;
        else if (environment === "chrome") return defaultPremiumModel;
        else if (environment.includes("mobile")) {
            if (approxTokens <= 45000) return defaultPremiumModel;
            else return defaultPremiumModel;
        }
        else if (environment.includes("web")) return defaultPremiumModel;

        else return defaultPremiumModel;
    }
}
